import { type RichiestaModuloDTOStatoValidazione } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTOStatoValidazione.ts';
import { type SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import { SubmissionHeadingTitle } from '@framework/common-web/ui/inquiry/submission/SubmissionHeadingTitle.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import type React from 'react';
import styled from 'styled-components';
import { ModuleStateProgressBar } from './ModuleStateProgressBar.tsx';

const SubmissionNavTitleWrapper = styled.div`
  padding: 12px 0;
  padding-top: 24px;
  padding-top: 0;
`;

const SubmissionNavTitle = styled(SubmissionHeadingTitle)`
  &&& {
    margin: 0;
    padding: 0;
  }
`;

export interface ISubmissionTitleProps {
  currentTitle?: React.ReactNode;
  moduleState: SubmissionModuleState;
  validationState: RichiestaModuloDTOStatoValidazione | null | undefined;
  hasSignatures: boolean;
  /** Se la richiesta è inviata, non deve essere visualizzato */
  hideProgressBar?: boolean;
}

/**
 * Titolo di un modulo di richiesta. Include anche la barra di stato, se necessario.
 */
export function SubmissionTitle(props: ISubmissionTitleProps) {
  const {
    currentTitle,
    validationState,
    moduleState,
    hasSignatures,
    hideProgressBar,
  } = props;

  return (
    <SubmissionNavTitleWrapper>
      <FlexRow
        right={
          !hideProgressBar && (
            <ModuleStateProgressBar
              currentState={moduleState}
              hasSignatures={hasSignatures}
              isValid={validationState?.valido}
            />
          )
        }
      >
        <SubmissionNavTitle level={2}>{currentTitle}</SubmissionNavTitle>
      </FlexRow>
    </SubmissionNavTitleWrapper>
  );
}
